import { subscribe } from 'valtio'

import { runFatalDisconnects } from '../../FatalError/FatalError'
import { runWhenReady } from '../../firebase/firebaseConnection'
import { getLiveId } from '../../global/blocs/roomInfo'
import { logMessage } from '../../Logging/log'
import { roomState } from '../../webrtc/webRTCRoom'

const recoverRelay = (message: string) => {
  if (
    'relayRestartBrowser' in window &&
    typeof window.relayRestartBrowser === 'function'
  ) {
    window.relayRestartBrowser()
    return
  }

  if ('recoverRelay' in window && typeof window.recoverRelay === 'function') {
    window.recoverRelay('reload', message)
  }
}

const announceRoomReady = (info: { firebase: boolean; webrtc: boolean }) => {
  if ('roomReady' in window && typeof window.roomReady === 'function') {
    window.roomReady(info)
  } else {
    setTimeout(() => announceRoomReady(info), 1000)
  }
}

const reloadRoom = (reason: string, hard: boolean = false) => {
  logMessage(`Reloading headless — ${reason}`, {
    level: 'error',
  })

  void runFatalDisconnects()

  if (!hard) {
    // try window reloading first
    window.location.reload()

    // if page hasn't reloaded after 5s, ask relay to recover instead
    setTimeout(
      () => recoverRelay(`Page failed to reload for 2000s — ${reason}`),
      2000
    )
  } else {
    recoverRelay(reason)
  }
}

type HeadlessReloadResponse = {
  data: { action: string; action_reason: string }
}

const initReloadSupervisor = () => {
  const formData = new FormData()
  formData.set('live_id', `${getLiveId()}`)

  setInterval(() => {
    void fetch('/api/2/live/webinar/headless-reload', {
      method: 'POST',
      cache: 'no-cache',
      body: formData,
    })
      .then((response) => response.json())
      .then((response: HeadlessReloadResponse) => {
        if (response.data.action === 'reload') {
          reloadRoom(response.data.action_reason)
        }
      })
  }, 5000)

  let queuedReload: number

  window.addEventListener('offline', () => {
    queuedReload = window.setTimeout(() => {
      reloadRoom('Network dropped 2s ago', true)
    }, 2000)
  })

  window.addEventListener('online', () => {
    if (queuedReload) {
      window.clearTimeout(queuedReload)
    }
  })
}

// window.roomReady

const initReadySupervisor = () => {
  const isReady = { firebase: false, webrtc: false }
  let readyConfirmed = false

  const checkReady = () => {
    if (readyConfirmed) return
    if (isReady.firebase && isReady.webrtc) {
      announceRoomReady(isReady)
      readyConfirmed = true
    }
  }

  subscribe(roomState, () => {
    if (roomState.status === 'connected') {
      isReady.webrtc = true
      checkReady()
    }
  })
  runWhenReady(() => {
    isReady.firebase = true
    checkReady()
  })
}

export { reloadRoom, initReloadSupervisor, initReadySupervisor }
